import React, { useEffect, useState } from 'react';

import { SubmissionForm, FullScreenLoadingSpinner } from '@ui/components';

const OFFICE_365_LIBRARY_LOCATION = "https://appsforoffice.microsoft.com/lib/1.1/hosted/office.js";
const isBrowser = typeof window !== 'undefined';

export const SubmitPhishPanel = () => {
  const [officeScriptLoaded, setOfficeScriptLoaded] = useState(globalThis.Office !== undefined);
  const [isOfficeInit, setInitOffice] = useState(false);

  useEffect(() => {
    if (isBrowser) {
      // Loading the Office library via HTML will cause the BrowserRouter to break since office will nullify the history API
      if (!officeScriptLoaded && document.querySelector(`[src='${OFFICE_365_LIBRARY_LOCATION}']`) === null) {
        const officeScript = document.createElement('script');
        officeScript.src = OFFICE_365_LIBRARY_LOCATION;
        officeScript.onload = () => setOfficeScriptLoaded(true);
        document.body.appendChild(officeScript);
      }
      if (globalThis.Office) {
        (async () => {
          console.log("waiting for office")
          await Office.onReady();
          console.log("office ready")
          setInitOffice(true);
        })();
      }
    }
  }, [globalThis.Office]);


  return (
    <div>
      {isOfficeInit ? <SubmissionForm /> : <FullScreenLoadingSpinner />}
    </div>
  );
};
